// Cousine.js
import React from "react";
import Ingredients from "../assets/dish1.jpg";
import { SectionLayout } from "./SectionLayout";

export const Cousine = () => {
  return (
    <SectionLayout
      textLeft={true}
      title="Färska Ingredienser, Äkta Smaker"
      text="Den bästa italienska maten börjar med de bästa råvarorna. Vi samarbetar med noggrant utvalda lokala producenter och importerar förstklassiga ingredienser från Italien för att säkerställa att varje rätt är fylld med smak och autenticitet. Från handgjord pasta till omsorgsfullt utvalda ingredienser – vi levererar en kulinarisk upplevelse du sent kommer att glömma.
"
      image={Ingredients}
      altText="Färska italienska ingredienser"
      button={{
        text: "Upptäck Menyn",
        link: "menu",
      }}
      motionProps={{
        titleMotion: {
          whileInView: { x: 0, opacity: 1 },
          initial: { x: -20, opacity: 0 },
          viewport: { once: true, amount: 0.3 }, // Trigger animation when 30% is in view
          transition: { duration: 1 },
        },
        textMotion: {
          whileInView: { x: 0, opacity: 1 },
          initial: { x: -20, opacity: 0 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 1 },
        },
        imageMotion: {
          whileInView: { opacity: 1, scale: 1 },
          initial: { opacity: 0, scale: 0.8 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 1 },
        },
      }}
    />
  );
};
